import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/ship-luggage-internationally.jpg'),
    alt: 'ship luggage internationally page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'ship luggage internationally page search image',
    width: 92,
    height: 92
  }
]

export const heroSectionContent = {
  title: 'Fast and <span>Secure</span><span>Storage and International Shipping</span>',
  description:
    'Looking for secure storage and fast international shipping? ShipAndStorage offers a one-stop solution for all your storage and shipping needs, ensuring your items are handled with care and delivered to any destination worldwide.',
  points: [
    'Up to 6 Months Free Storage',
    'Free Insurance up to $250',
    '1 Small Box to 100 Large Box Storage',
    'Storage Services with Freedom'
  ],
  image: {
    url: '/images/v2/pages/landing-pages/ship-luggage-internationally/hero-image.png',
    alt: 'storage and international shipping page'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Sign Up to Ship Luggage Internationally' }
}

export const helperGuideSection = {
  title: 'How We Make Sure Fast And Secure International Shipping',

  ctaButton: { href: PUBLIC_MAIN_ROUTES.HOW_SHIP_AND_STORAGE_WORKS.href, text: 'Learn More' },
  cards: [
    {
      id: 1,
      title: 'Book Your Service',
      description: 'Select the storage and international luggage shipping option that meets your specific needs.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-luggage-internationally/book-your-service.svg',
        alt: 'Book Your Service service'
      }
    },
    {
      id: 2,
      title: 'Schedule a Pickup',
      description: 'We arrange a hassle-free pickup from your location at a time that works best for you.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-luggage-internationally/schedule-a-pickup.svg',
        alt: 'Schedule a Pickup service'
      }
    },
    {
      id: 3,
      title: 'Secure Storage & Shipping',
      description:
        'Your items are stored safely in our secure facilities, ready for shipping whenever you need them, ensuring timely and cost-effective delivery.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-luggage-internationally/secure-storage-shipping.svg',
        alt: 'Secure Storage & Shipping service'
      }
    },
    {
      id: 4,
      title: 'Fast And Secure Luggage Shipping Worldwide',
      description:
        'At ShipAndStorage, we specialize in shipping luggage globally with speed and security. Our partnerships with trusted carriers like FedEx, DHL, and UPS ensure your luggage arrives at its destination on time and in perfect condition, backed by secure packaging and full tracking services.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-luggage-internationally/fast-and-secure-luggage-shipping-worldwide.svg',
        alt: 'Fast And Secure Luggage Shipping Worldwide service'
      }
    }
  ]
}

export const whySelfStorageSectionContent = {
  title: 'Why Self Storage Service Is Necessary?',

  cards: [
    {
      id: 1,
      title: 'Organize and De-clutter',
      description:
        'Create additional space in your home or office by storing items that are rarely needed. Our storage options help foster a tidy and organized environment.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-luggage-internationally/organize-and-declutter.svg',
        alt: 'Organize and De-clutter'
      }
    },
    {
      id: 2,
      title: 'Easy Moving Solutions',
      description:
        'Facilitate a smooth moving experience by using temporary storage for your belongings. Store furniture and other essentials safely until you’re ready to relocate.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-luggage-internationally/easy-moving-solutions.svg',
        alt: 'Easy Moving Solutions'
      }
    },
    {
      id: 3,
      title: 'Secure Storage for Seasonal Items',
      description:
        'Protect your seasonal decorations, sports equipment, or treasured items in our secure storage facilities, available for both short and long durations.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-luggage-internationally/secure-storage-for-seasonal-items.svg',
        alt: 'Secure Storage for Seasonal Items'
      }
    }
  ]
}

export const gridSectionContent = {
  title: 'Who Should Choose ShipAndStorage Service for International Storage?',

  cards: [
    {
      id: 1,
      title: 'International College Students',
      description: 'Safely store dorm essentials during summer break or when traveling back home.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-luggage-internationally/international-college-students.svg',
        alt: 'International College Students'
      }
    },
    {
      id: 2,
      title: 'Global Nomads and Expats',
      description: 'Keep personal belongings secure while on extended assignments or travels abroad.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-luggage-internationally/global-nomads-and-expats.svg',
        alt: 'Global Nomads and Expats'
      }
    },
    {
      id: 3,
      title: 'Professionals Relocating Overseas',
      description: 'Avoid moving costs by storing essentials in a secure facility until you’re back.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-luggage-internationally/professionals-relocating-overseas.svg',
        alt: 'Professionals Relocating Overseas'
      }
    },
    {
      id: 4,
      title: 'Study Abroad Students',
      description: 'Store items during your time abroad, so they’re ready when you return to campus.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-luggage-internationally/study-abroad-students.svg',
        alt: 'Study Abroad Students'
      }
    },
    {
      id: 5,
      title: 'Frequent Movers Across Borders',
      description: 'Simplify your move by storing furniture or personal belongings between destinations.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-luggage-internationally/frequent-movers-across-borders.svg',
        alt: 'Frequent Movers Across Borders'
      }
    },
    {
      id: 6,
      title: 'Businesses Serving International Markets',
      description: 'Store trade show displays, documents, or inventory for easy local access and distribution.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-luggage-internationally/businesses-serving-international-markets.svg',
        alt: 'Businesses Serving International Markets'
      }
    }
  ]
}

export const evenOddList = {
  title: 'Our Different Storage Services',

  articles: [
    {
      id: 1,
      title: 'Business Storage Solution',
      description:
        'We provide flexible storage for businesses during relocations or global expansions, making sure all essential items are safely stored and easily accessible.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-luggage-internationally/business-storage-solution.svg',
        alt: 'Business Storage Solution'
      },
      link: {
        text: 'Explore Business Storage',
        href: PUBLIC_MAIN_ROUTES.BUSINESS_STORAGE.href
      }
    },
    {
      id: 2,
      title: 'Moving Storage Solution',
      description:
        'Simplify your international move with tailored storage options for everything from luggage to larger personal belongings, with delivery when you need it.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-luggage-internationally/moving-storage-solution.png',
        alt: 'Moving Storage Solution'
      },
      link: {
        text: 'Explore Moving Storage',
        href: PUBLIC_MAIN_ROUTES.MOVING_STORAGE_SOLUTIONS.href
      }
    },
    {
      id: 3,
      title: 'Luggage and Box Shipping Services',
      description:
        "Ship single or multiple pieces of luggage internationally. Whether it's one small suitcase or a dozen large boxes, we ensure safe and timely delivery.",
      image: {
        src: '/images/v2/pages/landing-pages/ship-luggage-internationally/luggage-and-box-shipping-services.svg',
        alt: 'Luggage and Box Shipping Services'
      },
      link: {
        text: 'Explore Luggage & Box Shipping',
        href: PUBLIC_MAIN_ROUTES.LUGGAGE_BOX_SHIPPING_SERVICES.href
      }
    },
    {
      id: 4,
      title: 'Residential Storage Services',
      description:
        'Our residential storage services offer secure, affordable storage for personal items with convenient access and flexible terms, ensuring your items are safe during any transition.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-luggage-internationally/residential-storage-services.svg',
        alt: 'Residential Storage Services'
      },
      link: {
        text: 'Explore Residential Storage',
        href: PUBLIC_MAIN_ROUTES.RESIDENTIAL_STORAGE.href
      }
    }
  ]
}

export const whyChooseUsSectionContent = {
  title: 'Why Choose ShipAndStorage for Shipping Luggage Internationally?',

  cards: [
    {
      id: 1,
      title: 'Trusted Expertise',
      description:
        'With years of experience, ShipAndStorage guarantees your luggage is shipped safely, securely, and delivered on time to any international destination.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-luggage-internationally/trusted-expertise.svg',
        alt: 'Trusted Expertise'
      }
    },
    {
      id: 2,
      title: 'Tailored Solutions',
      description:
        'Whether you need to ship one suitcase or manage an entire international relocation, we provide customized solutions that fit your needs perfectly.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-luggage-internationally/tailored-solutions.svg',
        alt: 'Tailored Solutions'
      }
    },
    {
      id: 3,
      title: 'Affordable Rates',
      description:
        'We offer competitive pricing without compromising on quality or security, making us the ideal choice for your international luggage shipping needs.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-luggage-internationally/affordable-rates.svg',
        alt: 'Affordable Rates'
      }
    }
  ]
}

export const infoBannerSectionContent = {
  id: 1,
  title: 'Ship Luggage Internationally Fast Secure And Affordable',
  description:
    'Ship luggage internationally fast and affordably. Secure, reliable, and convenient solutions for shipping your luggage worldwide.',
  image: {
    src: '/images/v2/pages/landing-pages/ship-luggage-internationally/ship-luggage-internationally-fast-secure-and-affordable.svg',
    alt: 'Ship Luggage Internationally Fast Secure And Affordable'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Get Started' }
}

export const faqSectionContent = {
  title: 'Our Shipping Partners',
  description:
    'At ShipAndStorage, we provide top-tier shipping and storage services through partnerships with renowned global carriers like FedEx, DHL, and UPS. These trusted partners ensure your items are shipped internationally with speed, reliability, and care.',
  questions: [
    {
      id: 1,
      question: 'FedEx',
      answer:
        'Founded in 1971 by Frederick W. Smith, FedEx started with a modest 186 packages and has grown into a global leader in the shipping industry. With a robust fleet of 696 aircraft and 215,000 vehicles, FedEx handles an astounding 16 million shipments daily, reaching over 220 countries and territories. With more than 550,000 employees and over 5,000 centers globally, FedEx guarantees fast, dependable deliveries.|||Disclaimer|||This information was last updated in September 2024 and is for reference purposes only. FedEx makes no warranties, express or implied, regarding the accuracy of the information provided.'
    },
    {
      id: 2,
      question: 'DHL',
      answer:
        'DHL Express, a key division of Deutsche Post DHL Group, is a leader in international courier and express mail services. Handling over 1.8 billion parcels each year, DHL plays a vital role in global logistics. Founded by Adrian Dalsey, Larry Hillblom, and Robert Lynn, and fully acquired by Deutsche Post in 2002, DHL now operates in more than 220 countries worldwide, ensuring a seamless connection across the globe.|||Disclaimer:|||The information above was last updated in September 2024 for reference only. DHL makes no warranties regarding the accuracy of the provided data. For more details, visit DHL.com. DHL® is a registered trademark of DHL International GmbH. All rights reserved.'
    },
    {
      id: 3,
      question: 'UPS',
      answer:
        'Founded in Seattle in 1907 as the American Messenger Company by teenagers Claude Ryan and Jim Casey, UPS has evolved into one of the largest shipping companies in the world. Rebranded as United Parcel Service in 1919, UPS now handles 25 million packages daily with over 500,000 employees. Serving over 220 countries and territories, UPS offers unmatched global reach and reliability.|||Disclaimer:|||The information on this page was last updated in September 2024 and is intended for reference only. UPS makes no warranties concerning the accuracy of this content For more details, visit UPS.com. UPS® is a registered trademark of UPS Inc. All rights reserved.'
    }
  ]
}
